import React from "react";
import { flexCenter, styled } from "@100mslive/roomkit-react";
import PreviewJoin from "./PreviewJoin";

const PreviewContainer = ({
  token,
  onJoin,
  env,
  skipPreview,
  initialName,
  asRole,
}) => {
  return (
    <Container>
      <PreviewJoin
        initialName={initialName}
        skipPreview={skipPreview}
        env={env}
        onJoin={onJoin}
        token={token}
        asRole={asRole}
      />
    </Container>
  );
};

const Container = styled("div", {
  maxWidth: "600px",
  width: "100%",
  ...flexCenter,
  flexDirection: "column",
  backgroundColor: "#FFFFFF",
  borderRadius: "$2",
  border: "1px solid $border_bright",
  padding: "$12 $10",
  "@sm": {
    margin: "$8",
    padding: "$10 $8",
  },
});

export default PreviewContainer;
